<template>
  <div class="ddcontent">
    <div class="line_bottom"  v-for="(item, index) in caseList" :key="index">
      <div class="edge">
        <div class="pic"  @click="checkFile(item.filePath, item.fileName)">
          <img v-if="item.fileType == 'pdf' " src="../../../../assets/appraise/ic_pdf.png" />
          <img v-if="item.fileType == 'doc' " src="../../../../assets/appraise/ic_doc.png" />
          <img v-if="item.fileType == 'exl' " src="../../../../assets/appraise/ic_exl.png" />
        </div>
        <div class="text"  @click="checkFile(item.filePath, item.fileName)">{{ item.fileName }}.{{ item.fileType }}</div>
        <img class="imgdiv" @click="deleteFile(index)" src="../../../../assets/appraise/delete.png" />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "materialScience_delete",
  props: {
    caseList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    deleteFile(index){
      this.$emit('deleteFiel', index);
   
    //  this.caseList = newdata;
    },
    checkFile(url, name) {
    }
  }
};
</script>
<style lang="less" scoped>
.ddcontent{
    padding: 0 12px 0 0;
}
.edge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .text {
    flex: 1;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 24px;
    color: rgba(51, 51, 51, 1);
    // text-overflow: -o-ellipsis-lastline;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-line-clamp: 2;
    // line-clamp: 2;
     word-break: break-all;
    -webkit-box-orient: vertical;
    padding-right: 32px;
    margin-left: 12px;
  }
  .pic {
    width: 34px;
    height: 38px;
  }
  .imgdiv {
    width: 15px;
    height: 16px;
  }
}
.line_bottom::after{
    background: none;
}

.line_bottom{
    padding: 0 0 16px 0;
}
</style>
